import { Vertragsoptionen } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../../store/appState';

export const selectVertragsoptionen = (state: IAppState): Vertragsoptionen =>
  state.vertragsoptionen;

export const selectIsNeugeschaeft = (state: IAppState): boolean =>
  !state.vertragsoptionen.vorvertragsNummern ||
  state.vertragsoptionen.vorvertragsNummern.length === 0;

export const selectZahlweise = (state: IAppState): string =>
  state.vertragsoptionen.zahlungsweise.toLowerCase();

export const selectZuerszone3ActiveInErsatzgeschaeft = (state: IAppState): boolean => {
  const isErsatzgeschaeft =
    state.vertragsoptionen.vorvertragsNummern?.length > 0 && !state.vertragsoptionen.beibehalten;
  return (
    isErsatzgeschaeft &&
    state.risikoort.zuerszone === 3 &&
    !state.vorschaeden.elementarVorschaden.countFromRisikoortService
  );
};
